import React from 'react';
import SchemeManagementSectionContainer from '../../SchemeManagementSectionContainer/SchemeManagementSectionContainer';
import { Col, Form, Row } from 'react-bootstrap';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { InfoLabel } from '../../../../../common/components';
import displayName from '../../../../../helpers/displayName';
import SelectField from '../../../../../common/components/ReduxFormField/SelectField';

const REGIONS = [
  {
    value: 1,
    label: '1',
  },
  {
    value: 2,
    label: '2 (no longer supported)',
  },
  {
    value: 3,
    label: '3 (no longer supported)',
  },
  {
    value: 4,
    label: '4',
  },
  {
    value: 5,
    label: '5 (no longer supported)',
  },
  {
    value: 6,
    label: '6',
  },
];
const MedicalScreeningRegionMapping = ({ handleSubmit, formValues, isViewOnly }) => {
  const regions = formValues?.meta?.config?.parameters?.region?.enum ?? [];

  return (
    <SchemeManagementSectionContainer
      title={''}
      subTitle={'Medical Region Mapping'}
      isViewOnly={isViewOnly}
    >
      <Form horizontal onSubmit={handleSubmit}>
        <Row className="section-item">
          <Col sm={12}>
            {regions.map((region) => (
              <Field
                label={displayName(region)}
                labelSize={2}
                smFieldSize={2}
                name={`meta.config.parameters.medical_screening_regions.${region}`}
                options={REGIONS}
                format={parseInt}
                parse={parseInt}
                component={isViewOnly ? InfoLabel : SelectField}
              />
            ))}
          </Col>
        </Row>
      </Form>
    </SchemeManagementSectionContainer>
  );
};
export default compose(
  connect((state, props) => {
    return {
      formValues: getFormValues(props.formName)(state),
      destroyOnUnmount: false,
      enableReinitialize: true,
      form: props.formName,
    };
  }),
  reduxForm({}),
)(MedicalScreeningRegionMapping);
